module.exports = __webpack_public_path__ + "static/img/jumperU-1.f0ef19c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/jumperU-1.svg
// module id = 6bSB
// module chunks = 0